import { FC, Suspense, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpRespPersonalizedItemsCarouselLoading } from './PdpRespPersonalizedItemsCarouselLoading';

import { PdpRespPersonalizedItemsCarouselLazy_viewer$key } from './__generated__/PdpRespPersonalizedItemsCarouselLazy_viewer.graphql';
import { PdpRespPersonalizedItemsCarouselLazy_user$key } from './__generated__/PdpRespPersonalizedItemsCarouselLazy_user.graphql';

export const PdpRespPersonalizedItemsCarousel = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpRespPersonalizedItemsCarousel" */ './PdpRespPersonalizedItemsCarousel'
        )
);

type Props = {
    viewer: PdpRespPersonalizedItemsCarouselLazy_viewer$key;
    user: PdpRespPersonalizedItemsCarouselLazy_user$key;
    currency: string;
    isClient: boolean;
};

const viewerFragment = graphql`
    fragment PdpRespPersonalizedItemsCarouselLazy_viewer on Viewer {
        ...PdpRespPersonalizedItemsCarousel_viewer @include(if: $isClient)
    }
`;

const userFragment = graphql`
    fragment PdpRespPersonalizedItemsCarouselLazy_user on User {
        ...PdpRespPersonalizedItemsCarousel_user @include(if: $isClient)
    }
`;

export const PdpRespPersonalizedItemsCarouselLazy: FC<Props> = ({
    viewer: viewerRef,
    user: userRef,
    currency,
    isClient,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);

    if (!isClient) {
        return <PdpRespPersonalizedItemsCarouselLoading />;
    }

    return (
        <Suspense fallback={<PdpRespPersonalizedItemsCarouselLoading />}>
            <PdpRespPersonalizedItemsCarousel viewer={viewer} user={user} currency={currency} />
        </Suspense>
    );
};
